import { $fromParent, syncValues } from '../utils';
import { format } from 'date-fns';

const bookingConsole = {
  format: {
    dash: 'YYYY-MM-DD',
    datepick: 'mm/dd/yyyy'
  },

  init(hotels, locations) {
    function filterRequiredAttributes(list, isHotel) {
      if(list && list.length > 0){
        let filteredList,
            uniCodeList = [];
        filteredList = list.map(({city, country, state_name, value, data, code, special_character}) => {
          let property = {};
          property = {
              city,
              state_name,
              country,
              value
          };
           if(isHotel) {
            let doubleCommaFilterd = {};
            if(data.location) {
              doubleCommaFilterd['location'] = data.location.replace(/,\s?,/g, ', ');
            }
            property['data'] = doubleCommaFilterd;
            if(special_character) {
                  const uniCodeProperty = Object.assign({}, property);
                  uniCodeProperty.value = code[0].toUpperCase() + code.substring(1); 
                  uniCodeList.push(uniCodeProperty);
             }
          }
          return property;
        })
        return  filteredList.concat(uniCodeList);
     }
    }
    this.locations = filterRequiredAttributes(locations) || [];
    this.hotels = filterRequiredAttributes(hotels, true) || [];
    this.autocomplete();
    this.datepickerDefault();
    this.datepickerRFG();
    this.numberOfGuests();
    this.promocode();
    this.validation();
  },

  autocomplete() {
    const $hotelSearch = $('#hotel-search');
    const $hotelSearchModal = $('#hotel-search-modal');
    
    const options = {
      groupBy: 'location',
      lookup: this.locations.concat(this.hotels),
      lookupLimit: 15,
      minChars: 3,
      onSelect(suggestion) {
        const value = suggestion.value && suggestion.value.replace(/,\s?,/g, ',');
        $('.hotel-search').val(value);
      }
    };

    $hotelSearch.autocomplete(options);
    $hotelSearchModal.autocomplete(options);

    setTimeout(() => {
      syncValues($('.hotel-search'));
    }, 0);
  },

  datepickerKeyup($datepicker) {
    const events = [];
    const key = {
      enter: 13,
      esc: 27,
      tab: 9
    };

    $(document).on('keyup', e => {
      const $nextArrow = $fromParent($datepicker, '.datepick-cmd-next');
      const $prevArrow = $fromParent($datepicker, '.datepick-cmd-prev');
      const $selected = $fromParent($datepicker, '.datepick-selected');
      const prevEvent = events[events.length - 1];

      if (e.keyCode === key.tab) {
        events.push(event.target);
      }

      if (e.keyCode === key.esc) {
        $datepicker.datepick('hide');
      }

      if (e.keyCode === key.enter) {
        if ($(prevEvent).hasClass('datepick-cmd-prev')) {
          $prevArrow.focus();
        } else if ($(prevEvent).hasClass('datepick-cmd-next')) {
          $nextArrow.focus();
        } else {
          $selected.focus();
        }
      }
    });
  },

  datepickerOptions({
    onSelect = () => {},
    popupContainer,
    rangeSelect = true
  }) {
    const { datepick } = this.format;

    return {
      rangeSelect,
      minDate: new Date(),
      monthsToShow: 1,
      dateFormat: datepick,
      showAnim: 'slideDown',
      showSpeed: 'fast',
      popupContainer,
      closeText:
        '<div class="close-calendar-wrapper"><div class="close-calendar-one"></div><div class="close-calendar-two"></div></div>',
      nextText: '<i class="fa fa-caret-right"></i>',
      prevText: '<i class="fa fa-caret-left"></i>',
      onSelect(dates) {
        onSelect(dates);
      },
      onShow() {
        const $header = $('.datepick-month-header');
        const $selected = $('.datepick-month-year option:selected').text();
        const month = $selected.match(/[a-zA-Z]+/g);
        const year = $selected.match(/[0-9]+/g);

        $header.text('');
        $header.append(
          `<h2 class="custom-month-year">${month} ${year}</h2 class="custom-month-year"><div class="header-underline"></div>`
        );
      }
    };
  },

  datepickerDefault() {
    const { dash } = this.format;
    const $datepicker = $('#date-in-out');
    const $datepickerModal = $('#date-in-out-modal');

    function onSelectCb(dates) {
      const $selectedDates = $($.datepick.curInst.elem).val();

      $datepicker.val($selectedDates);
      $datepickerModal.val($selectedDates);

      $('#arrivalDate').val(format(dates[0], dash));
      $('#departureDate').val(format(dates[1], dash));
    }

    $datepicker.datepick(
      this.datepickerOptions({
        onSelect(dates) {
          onSelectCb(dates);
        },
        popupContainer: $('.datepick-wrapper')
      })
    );

    $datepickerModal.datepick(
      this.datepickerOptions({
        onSelect(dates) {
          onSelectCb(dates);
        },
        popupContainer: $('.datepick-wrapper')
      })
    );

    this.datepickerKeyup($datepicker);
    this.datepickerKeyup($datepickerModal);
  },

  datepickerRFG() {
    const $startDateInput = $('#start-date');
    const $endDateInput = $('#end-date');
    let startDate;
    let endDate;

    function validate() {
      if (startDate > endDate) {
        $startDateInput.parsley().removeError('required');
        $startDateInput.parsley().addError('required', {
          message: 'Start date must be before end date.',
          updateClass: true
        });
      } else {
        $startDateInput.parsley().removeError('required');
      }
    }

    $startDateInput.datepick(
      this.datepickerOptions({
        onSelect(date) {
          startDate = date[0];

          validate();
        },
        popupContainer: $('.startdate-datepick-wrapper'),
        rangeSelect: false
      })
    );

    $endDateInput.datepick(
      this.datepickerOptions({
        onSelect(date) {
          endDate = date[0];

          validate();
        },
        popupContainer: $('.enddate-datepick-wrapper'),
        rangeSelect: false
      })
    );

    this.datepickerKeyup($startDateInput);
    this.datepickerKeyup($endDateInput);
  },

  numberOfGuests() {
    syncValues($('.grid-x .adults select'));
    syncValues($('.grid-x .children select'));
  },

  promocode() {
    const $promoModify = $('.promo-modify');

    $('.promo-trigger').on('click', e => {
      e.preventDefault();

      $promoModify.toggleClass('expanded');
      if ($promoModify.hasClass('expanded')) {
        $promoModify.find(':input').attr('tabindex', '0');
      } else {
        $promoModify.find(':input').attr('tabindex', '-1');
      }
    });

    syncValues($('.promo-code input'));
    syncValues($('.iata input'));
  },

  validation() {
    $('.reservations-console').parsley();
  }
};

export default bookingConsole;
